export enum OrderManagementTypes {
    GET_ORDERS_LIST_REQUEST = 'GET_ORDERS_LIST_REQUEST',
    GET_ORDERS_LIST_REQUEST_SUCCESS = 'GET_ORDERS_LIST_REQUEST_SUCCESS',
    GET_ORDERS_LIST_REQUEST_FAILURE = 'GET_ORDERS_LIST_REQUEST_FAILURE',

    GET_ORDERS_DETAIL_REQUEST = 'GET_ORDERS_DETAIL_REQUEST',
    GET_ORDERS_DETAIL_REQUEST_SUCCESS = 'GET_ORDERS_DETAIL_REQUEST_SUCCESS',
    GET_ORDERS_DETAIL_REQUEST_FAILURE = 'GET_ORDERS_DETAIL_REQUEST_FAILURE',
  }
  